import React, { useEffect, useContext } from 'react';;
import pluralize from 'pluralize';
import { GlobalContext } from '../context/GlobalState';
import {
  Hero,
  StickyNavbar,
  ComponentWrapper,
  Card,
  CardSlider,
  ComponentVerticalSpacing,
  EmailSignupModal,
  Svg,
  Instagram
} from 'day8-react/build/new-components';
import { pricingHelpers, useToggle } from 'day8-react';

// import WeeklyTabsWrapper from '../components/destination/WeeklyTabsWrapper';
import Intro from '../components/Intro';
import WhatsIncluded from '../components/WhatsIncluded';
import Overview from '../components/Destination/Overview';
import Highlights from '../components/Destination/Highlights';
import Itinerary from '../components/Destination/Itinerary';
import InfoCards from '../components/Destination/InfoCards';
import ChamonixHotels from '../components/Destination/ChamonixHotels';
import Accomodation from '../components/Destination/Accomodation';
import AccomodationOptions from '../components/Destination/AccomodationOptions';
import PageLayout from '../layouts/page';
import DestinationBlogPost from '../components/Destination/DestinationBlogPost';
import { BgImageType, CurrencyContextType, DestinationType, ToggleType, WpPageType } from '../globalTypes';
import { calculateMinPriceOnDestinationPerPerson } from '../helpers/pricing';

type DestinationPageWrapperType = {
  page: DestinationType
  destinations: DestinationType[]
  destinationBlogs?: []
  socialFeed: []
};

const DestinationPageWrapper = ({ page, destinations, destinationBlogs, socialFeed }: DestinationPageWrapperType) => {
  const [isIntercom, toggleIsIntercom] = useToggle();
  const { showCookieBanner } = useContext(GlobalContext);
  const destinationId = +page.acf.destination_id;
  useEffect(() => {
    if (destinationId === 2) {
      document.body.classList.add('destination-aspen');
    }
    if (destinationId === 3) {
      document.body.classList.add('destination-austria');
    }
    if (destinationId === 6) {
      document.body.classList.add('destination-japan');
    }
    if (destinationId === 5) {
      document.body.classList.add('destination-chamonix');
    }
    if (window.Intercom) toggleIsIntercom(true);

    return () => {
      document.body.classList.remove('destination-aspen');
      document.body.classList.remove('destination-austria');
      document.body.classList.remove('destination-japan');
      document.body.classList.remove('destination-chamonix');
    };
  }, [page]);
  const minPriceUnformatted = page && calculateMinPriceOnDestinationPerPerson(page);
  let currency;
  if (page && !!page.weeks?.length) {
    currency = page.weeks[0].currency;
  } else if (destinationId !== 2) {
    currency = 'EUR';
  } else {
    currency = 'USD';
  }
  const stickyNavbarText = page?.weeks
    && `${page.weeks.length} ${pluralize(
      'week',
      page.weeks.length
    )} available`;
  const stickyNavbarLink = `/book/weeks?dest=${destinationId}`;
  const stickyNavbarButtonText = 'See dates';
  const minPrice = minPriceUnformatted && page && pricingHelpers.formatCurrency(minPriceUnformatted / 100, currency);
  // const stickyNavbarText = destination && destination.weeks && `${destination.weeks.length} ${pluralize('week', destination.weeks.length)} available`;
  const isChamonix = destinationId === 5;


  const {
    hero, intro, highlights, included, accomodation, overview, stops, gallery, blog_posts
  } = page.acf;
  const addressBookId = page.acf.hero?.address_book_id;
  const showSignUpForm = page.acf.hero?.show_sign_up_form;
  return (
    <PageLayout
      page={page}
      signupHidden={page.acf && page.acf.hide_footer_signup}
    >
      <div className="relative">
        {hero && (
          <Hero
            title={hero.title}
            subtitle={hero.subtitle}
            bgImage={hero.background}
            video={hero.video}
            poster={hero.poster}
            template={hero.video ? 'Video' : 'Basic'}
            cta={hero.button}
            mobileVideo={hero.mobile_video}
            mobilePoster={hero.mobile_poster}
            mobileBgImage={hero.mobile_background}
            overlay
          />
        )}
        <a className="hero--scroll-arrow-center" href="#welcome">
          <Svg name="arrow-down" fill="#fff" />
        </a>
        <div id="welcome" />
      </div>
      {!!page?.fromPrice && (
        <StickyNavbar
          staticPosition
          showCookieBanner={showCookieBanner}
          topText={stickyNavbarText}
          price={page.fromPrice}
          buttonText={stickyNavbarButtonText}
          buttonLink={stickyNavbarLink}
          isIntercom={isIntercom}
        />
      )}
      <Intro intro={intro} />
      {gallery?.imagelist && (
        <div id="destination-gallery">
          <ComponentVerticalSpacing className="d8-u-bg-img destination-gallery-wrapper">
            <ComponentWrapper>
              <div>
                <CardSlider>
                  {gallery.imagelist.map(image => (
                    <div key={JSON.stringify(image)} className="flex flex-center margin-x-md">
                      <Card
                        template="ImageCard"
                        size={image.ratio}
                        bgImage={{
                          url: image.image.url,
                          alt: image.image.alt
                        }}
                      />
                    </div>
                  ))}
                </CardSlider>
              </div>
            </ComponentWrapper>
          </ComponentVerticalSpacing>
        </div>
      )}
      {overview && <Overview data={overview} />}
      {/* eslint-disable-next-line camelcase */}
      {!!blog_posts?.blog_post_category?.name
        && <DestinationBlogPost title={blog_posts.header} destinationBlogs={destinationBlogs} />
      }<div className="highlights-itinerary-wrapper d8-u-bg-img padding-y-xl">
        {highlights && (
          <ComponentVerticalSpacing noTop className="highlights-wrapper relative">
            <ComponentWrapper>
              <Highlights highlights={highlights} />
            </ComponentWrapper>
          </ComponentVerticalSpacing>
        )}
        {stops && (
          <ComponentVerticalSpacing noBottom className="itinerary-wrapper relative">
            <ComponentWrapper>
              <Itinerary days={stops} />
            </ComponentWrapper>
          </ComponentVerticalSpacing>
        )}
      </div>
      {included && <WhatsIncluded included={included} />}
      {accomodation && <Accomodation accomodation={accomodation} />}
      {isChamonix && <ChamonixHotels />}
      <ComponentVerticalSpacing>
        <ComponentWrapper>
          <AccomodationOptions destinationId={destinationId} />
        </ComponentWrapper>
      </ComponentVerticalSpacing>
      <ComponentVerticalSpacing>
        <ComponentWrapper>
          <Instagram socialFeed={socialFeed} />
        </ComponentWrapper>
      </ComponentVerticalSpacing>
      <ComponentVerticalSpacing noBottom>
        <ComponentWrapper>
          <InfoCards />
        </ComponentWrapper>
      </ComponentVerticalSpacing>
      {page.acf.signupmodal && page.acf.signupmodal.signupmodal && page.acf.signupmodal.signupmodal.show && (
        <EmailSignupModal
          timeout={10000}
          mobileLink={page.acf.signupmodal.signupmodal.mobilelink}
          title={page.acf.signupmodal.signupmodal.title}
          text={page.acf.signupmodal.signupmodal.text}
          image={page.acf.signupmodal.signupmodal.image}
          addressBookId={page.acf.signupmodal.signupmodal.addressbookid}
        />
      )}
    </PageLayout>
  );
};

export default DestinationPageWrapper;
